import styled, { css } from 'styled-components';
import { shade } from 'polished';

import { colors, radius } from '../../styles/tokens';

interface IButtonProps {
  imageMobile?: boolean;
  isDisabled?: boolean;
}

export const Container = styled.div<IButtonProps>`
  width: 220px;
  height: 40px;

  display: flex;
  cursor: pointer;

  justify-content: center;
  align-items: center;

  border: none;

  background-color: ${colors.primary};

  color: ${colors.onPrimary};

  border-radius: ${radius.full};

  transition: background-color 0.2s;

  &:hover {
    background-color: ${shade(0.2, colors.primary)};
  }

  ${props =>
    props.isDisabled &&
    css`
      cursor: not-allowed;
      opacity: 0.4;
      background-color: ${colors.surfaceContainerHighest};
      color: ${colors.onSurfaceVariant};

      &:hover {
        background-color: ${colors.surfaceContainerHighest};
      }
    `}

  span {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  img {
    display: none;
  }

  @media (max-width: 1199px) {
    width: auto;

    span {
      font-size: 12px;
      padding: 0 10px;
    }

    ${props =>
      props.imageMobile &&
      css`
        span {
          display: none;
        }

        img {
          display: block;
          width: 25px;
          height: 25px;
          margin: 5px;
        }
      `}
  }
`;
